<template>
  <Card class="contact-us">
    <span class="contact-us__title">💬 Message our team</span>
    <span>Questions or changes needed? We're here to help.</span>
    <Button color="green" invert @click="onClick" no-padding
      ><a :href="href" @click.prevent>Message our team</a></Button
    >
  </Card>
</template>

<script setup lang="ts">
import Card from '@/components/Theme2/Card.vue'
import Button from '@/components/Theme2/Button.vue'

defineProps<{
  onClick: () => void
}>()
</script>

<style lang="scss" scoped>
.contact-us {
  @include flex-column($spacing-3);
  padding: $spacing-6;

  align-items: flex-start;
  background-color: $green-50;

  .contact-us__title {
    font-weight: $font-semibold;
    font-size: $text-xl;
  }
}
</style>
